import "./Home.module.css";
import TopBarMainNavigation from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import PortfolioOverview from "./sections/PortfolioOverview";
import Features from "./sections/Features";
import Services from "./sections/Services";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import BrandsPartners from "./sections/BrandsPartners";
import LuxuryRenovationsUSP from "./sections/LuxuryRenovationsUSP";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <TopBarMainNavigation />
      <Hero />
      <Services />
      <AboutUs />
      <PortfolioOverview />
      <Features />
      <BrandsPartners />
      <WhatOurClientsSay />
      <LuxuryRenovationsUSP />
      <Footer />
    </div>;
}